var $ = require('jquery');
import inview from 'jquery-inview/jquery.inview';
import lazyLoad from 'vanilla-lazyload/dist/lazyload';
import Headroom from 'headroom.js';


let clickEvent = '';
if ('ontouchstart' in window) {
	clickEvent = 'touchstart';
} else {
	clickEvent = 'click tap';
}

$(function () {
	initInviewAnimate();
	initHeadroom();
	initLazyLoad();
	handleHeaderMenuToggling();
	initMobileDrawer();
	initAnchorScroll();
	customView();
});

$(window).on('load', function () {
	fixCF7MultiSubmit();
});

$(window).on('scroll', function () {
	var ua = window.navigator.userAgent;
	var isIE = /MSIE|Trident/.test(ua);
	if (!isIE) {
		checkActiveSection();
	}
	$(".menu li.active").blur();
});

function initHeadroom() {
	var headerElements = document.getElementsByClassName("site-header"),
		headerElementsNo = headerElements.length;

	if (headerElementsNo > 0) {
		for (var i = 0; i < headerElementsNo; i++) {
			var headroom = new Headroom(headerElements[i]);
			headroom.init();
		}
	}

	if (/\/news\//.test(window.location.href)) {
		$('.news').addClass('news-single');
	}
	if (/\/jobs\//.test(window.location.href)) {
		$('.jobs').addClass('jobs-single');
	}
}

function customView() {
	function isScrolledIntoView(elem) {
		var docViewTop = $(window).scrollTop(),
			docViewBottom = docViewTop + $(window).height(),
			elemTop = $(elem).offset().top,
			elemBottom = elemTop + $(elem).height();
		//Is more than half of the element visible
		return ((elemTop + ((elemBottom - elemTop) / 4.5)) >= docViewTop && ((elemTop + ((elemBottom - elemTop) / 4.5)) <= docViewBottom));
	}

	if ($(window).width() < 960) {
		$('.custom-inview').each(function () {
			if (isScrolledIntoView(this) === true) {
				$(this).addClass('inview-active');
			}
		});
		$(window).on('scroll', function () {
			$('.custom-inview').each(function () {
				if (isScrolledIntoView(this) === true) {
					$(this).addClass('inview-active');
				}
			});
		});
	} else {
		$(window).on('scroll', function () {
			$('.custom-inview').each(function () {
				if (isScrolledIntoView(this) === true) {
					$(this).addClass('inview-active');
				}
			});
		});
	}

	if (/\/news\//.test(window.location.href)) {
		$('.custom-inview').each(function () {
			if (isScrolledIntoView(this) === true) {
				$(this).addClass('inview-active');
			}
		});
		$(window).on('scroll', function () {
			$('.custom-inview').each(function () {
				if (isScrolledIntoView(this) === true) {
					$(this).addClass('inview-active');
				}
			});
		});
	}


}

function initLazyLoad() {
	const lazy = new lazyLoad({
		elements_selector: '.lazy',
		load_delay: 300
	});

	let variableSrc = 'src-desktop';
	if ($(window).width() < 768) {
		variableSrc = 'src-mobile';
	}

	const bgLazy = new lazyLoad({
		elements_selector: '.lazy-bg',
		data_bg: variableSrc,
		load_delay: 300
	});

	const imgLazy = new lazyLoad({
		elements_selector: '.lazy-img',
		data_src: variableSrc,
		load_delay: 300
	});

	let heroLazy = new lazyLoad({
		elements_selector: '.lazy-hero',
		data_bg: variableSrc,
		load_delay: 0
	});

	heroLazy.loadAll();
}

function initInviewAnimate() {
	var inviewElements = $(".inview-animate--fade")
		.add(".inview-animate--move-up")
		.add(".inview-animate--move-down")
		.add(".inview-animate--move-left")
		.add(".inview-animate--move-right")
		//.add( ".custom-inview" )
		.add(".inview-animate--scale");

	inviewElements.each(function () {
		var thisInviewElement = $(this);

		thisInviewElement.bind('inview', function (event, visible) {
			if (visible == true) {
				thisInviewElement.addClass('inview-active');
			}
		});
	});
}


function handleHeaderMenuToggling() {
	var header = $(".site-header"),
		headerMenu = $(".site-header__nav-wrap"),
		headerBurger = $(".site-header__nav-trigger, .site-drawer__menu-toggle-close");

	if (headerMenu.length) {
		headerBurger.on("click", function () {
			var index = 0;
			$('body').toggleClass('noscroll');
			$(this).toggleClass("active");
			headerMenu.toggleClass("menu-active menu-closed");
			header.toggleClass("nav-active");
		});
	}
	$('.menu-item a').on('click', function (e) {
		$('body,html').removeClass('noscroll');
		$('.site-header__nav').removeClass("active");
		$('.site-header__mobile-trigger').removeClass("active");
	})
}


function initMobileDrawer() {
	$('.site-header__mobile-trigger a').on('click', function (e) {
		e.preventDefault();
		$('.site-header__nav').toggleClass('active');
		$('.site-header__mobile-trigger').toggleClass('active');
		$('body, html').toggleClass('noscroll');
	});
}

function fixCF7MultiSubmit() {
	$('input.wpcf7-submit[type="submit"]').on('click', function () {
		var disabled = $(this).attr('data-disabled');
		if (disabled && disabled == 'disabled') {
			return false;
		} else {
			$(this).attr('data-disabled', 'disabled').addClass('hide-text');
			return true;
		}
	});

	$('.wpcf7').bind('wpcf7submit', function () {
		$(this).find('input.wpcf7-submit[type="submit"]').attr('data-disabled', 'enabled').removeClass('hide-text');
	});
}


function initAnchorScroll() {
	// Select all links with hashes
	$('a[href*="/#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.on('click', function (event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					$('.nav-primary .active').removeClass('active');
					$(this).parent().addClass('active');
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1000, function () {
						// Callback after animation
						// Must change focus!
						var $target = $(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						};
					});
				}
			}
		});
}

function checkActiveSection() {
	var windowTop = $(window).scrollTop();
	const isMobile = $(window).width() < 992
	$('[data-scroll]').each(function (index, elem) {
		var offsetTop = $(elem).offset().top,
			outerHeight = $(this).outerHeight(true);
		if (windowTop > (offsetTop - (isMobile ? 150 : 450)) && windowTop < (offsetTop + Math.abs(outerHeight))) {
			var elemId = $(elem).data('scroll');
			$(".menu li.active").removeClass('active');
			$(".menu li a[href='/#" + elemId + "']").parent().addClass('active');
		} else if ($(window).scrollTop() + $(window).height() > $(document).height() - 350) {
			$(".menu li.active").removeClass('active');
			$(".menu li a[href='/#contact']").parent().addClass('active');
		}
		if ($(window).scrollTop() < (isMobile ? 200 : 400)) {
			$(".menu li a[href='/#paq-approach']").parent().removeClass('active');
		}
	});
}

/* menu active on specified url */
document.addEventListener('DOMContentLoaded', function () {
	const currentUrl = window.location.href;
	const anchors = document.querySelectorAll('.menu-item a'); // Select all anchor tags inside menu items

	if (currentUrl.includes('/news-archive')) {
		anchors.forEach(anchor => {
			if (anchor.getAttribute('href') === '/#news-and-media') { // Check if href matches
				const parentMenuItem = anchor.closest('.menu-item'); // Find the closest parent <li>
				if (parentMenuItem) {
					parentMenuItem.classList.add('page-active'); // Add active class to the parent <li>
				}
			}
		});
	}
});